"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("./");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: 500;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0 25px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents.default.div(_templateObject());

var Explanation = _styledComponents.default.p(_templateObject2());

var InfoCallout = function InfoCallout(_ref) {
  var calloutText = _ref.calloutText,
      explanationText = _ref.explanationText,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["calloutText", "explanationText"]);
  return /*#__PURE__*/_react.default.createElement(Container, rest, /*#__PURE__*/_react.default.createElement(_.SecondaryH2, null, calloutText), /*#__PURE__*/_react.default.createElement(Explanation, null, explanationText));
};

InfoCallout.propTypes = {
  /** Prominent text that should get the user's attention for the explanation */
  calloutText: _propTypes.default.string.isRequired,

  /** An explanation for the callout */
  explanationText: _propTypes.default.node.isRequired
};
var _default = InfoCallout;
exports.default = _default;